module.exports = __webpack_public_path__ + "static/media/wear_mask.61553a8e.png";